import React from 'react';
import {
    Chip, FormControl, IconButton, Input, InputLabel
} from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import { KEY_CODES } from '../../../utils/constants';

const styles = () => ({
    chip: {
        margin: '4px 2px',
        maxWidth: '300px'
    },
    inputWrapper: {
        width: '100%',
        marginTop: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    chipWrapper: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    input: {
        width: '100%',
    }
});

class ProductTitleMultiInput extends React.Component {
    state = {
        isInputFocus: false
    }

    handleKeyUp = e => {
        if (e.keyCode === KEY_CODES.Enter && this.props.value) {
            this.props.onChangeMultiInput(e.target.value);
        }
    }

    handleDelete = value => () => {
        if (value) {
            const filteredData = this.props.values.filter((el, i) => i !== value);
            this.props.onDeleteValue(filteredData);
        } else {
            this.props.onDeleteValue([]);
        }
    }

    handleChange = e => this.props.onChangeValue(e.target.value);

    handleRemoveAllItems = () => this.props.onDeleteValue([])

    onFocus = () => this.setState({ isInputFocus: true });

    onBlur = () => this.setState({ isInputFocus: false });

    render() {
        const { classes, values, value, t } = this.props;
        const isShrinkLabel = !!values.length || !!value.length || this.state.isInputFocus;
        return (
            <FormControl>
                <InputLabel
                    variant="standard"
                    shrink={isShrinkLabel}
                >
                    {t('productName')}
                </InputLabel>
                <div className={classes.inputWrapper}>
                    <div className={classes.chipWrapper}>
                        {values.map((el, index) => (
                            <Chip
                                key={`${el}_${index}`}
                                className={classes.chip}
                                size="medium"
                                onDelete={this.handleDelete(index)}
                                label={el.value}
                            />
                        ))}
                    </div>
                    {values.length ? (
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={this.handleDelete()}
                        >
                            <DeleteIcon />

                        </IconButton>
                    ) : null}

                </div>
                <Input
                    value={this.props.value}
                    onChange={this.handleChange}
                    onKeyDown={this.handleKeyUp}
                    className={classes.input}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                />
            </FormControl>
        );
    }
}

ProductTitleMultiInput.propTypes = {
    classes: PropTypes.shape({
        container: PropTypes.string,
        chip: PropTypes.string,
    }),
    onChangeMultiInput: PropTypes.func,
    onDeleteValue: PropTypes.func,
    onChangeValue: PropTypes.func,
    value: PropTypes.string,
    values: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
        }))
};

export default withStyles(styles)(ProductTitleMultiInput);
